import { toDayJs } from '@helpers'

const hasSessionExpired = (endDate, hoursOffset = 0) => {
  return toDayJs().diff(toDayJs(endDate), 'hours') >= hoursOffset
}

export default hasSessionExpired
